<template>
  <div class="inline-block py-4 text-base" v-html="dataLocales.data.text"></div>
</template>
<script setup lang="ts">
import DataLocale from "~~/config/interface/DataLocale";

const dataLocales = new DataLocale([
  {
    locale: "en",
    text: "<p> 📢 Uploaded files will display ads. If you want to upload without restrictions, please use our <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Advanced Editor</a>.</p>",
  },
  {
    locale: "vi",
    text: "<p> 📢 Các tệp đã được tải lên sẽ hiển thị quảng cáo. Nếu bạn muốn tải lên mà không bị hạn chế, vui lòng sử dụng <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Trình chỉnh sửa Nâng cao của chúng tôi</a>.</p>",
  },
  {
    locale: "fr",
    text: "<p> 📢 Les fichiers téléchargés afficheront des publicités. Si vous souhaitez télécharger sans restrictions, veuillez utiliser notre <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Éditeur Avancé</a>.</p>",
  },
  {
    locale: "es",
    text: "<p> 📢 Los archivos cargados mostrarán anuncios. Si desea cargar sin restricciones, utilice nuestro <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Editor Avanzado</a>.</p>",
  },
  {
    locale: "de",
    text: "<p> 📢 Hochgeladene Dateien zeigen Werbung an. Wenn Sie ohne Einschränkungen hochladen möchten, verwenden Sie bitte unseren <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Erweiterten Editor</a>.</p>",
  },
  {
    locale: "ja",
    text: "<p> 📢 アップロードされたファイルには広告が表示されます。制限なしでアップロードしたい場合は、<a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>高度なエディタ</a>をご利用ください。</p>",
  },
  {
    locale: "zh",
    text: "<p> 📢 上传的文件将显示广告。如果您想无限制地上传，请使用我们的<a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>高级编辑器</a>。</p>",
  },
  {
    locale: "nl",
    text: "<p> 📢 Geüploade bestanden zullen advertenties weergeven. Als u zonder beperkingen wilt uploaden, gebruik dan onze <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Geavanceerde Editor</a>.</p>",
  },
  {
    locale: "nl",
    text: "<p> 📢 Geüploade bestanden zullen advertenties weergeven. Als u zonder beperkingen wilt uploaden, gebruik dan onze <a href='https://app.qrgateway.com/sign-in' class='font-semibold text-success'>Geavanceerde Editor</a>.</p>"  ,
  },
]);
</script>
